const ErrorBoundaryFallback = () => {

	return <>An error occurred</>
}

export default ErrorBoundaryFallback